import { PropsWithChildren } from 'react';

import { Outlet, useOutletContext } from 'react-router';
import { useRecoilValue } from 'recoil';

import { Box, Stack } from '@mui/material';

import PrimaryNavDrawer from '@/components/shared/PrimaryNavDrawer/PrimaryNavDrawer';
import { isDrawerLockedAtom } from '@/components/shared/PrimaryNavDrawer/PrimaryNavStore';
import { OutletContext } from '@/pages/Guards/WithRouteContext';
import InAppNotificationProvider from '@/providers/InAppNotificationProvider';
import theme from '@/theme';

const BaseLayoutWrapper = ({
  children,
  PrimaryNav,
}: PropsWithChildren<{ PrimaryNav: JSX.Element }>) => {
  const isDrawerLocked = useRecoilValue(isDrawerLockedAtom);

  return (
    <Stack direction="row" sx={{ display: isDrawerLocked ? 'flex' : 'block' }}>
      {PrimaryNav}

      <Box
        sx={{
          ml: isDrawerLocked ? 0 : 8,
          flexGrow: isDrawerLocked ? 1 : null,
          overflow: 'hidden',
          transition: `margin 0.5s ${theme.transitions.easing.easeInOut}`,
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};

const BaseLayout = () => {
  const context = useOutletContext<OutletContext | null>();

  return (
    <BaseLayoutWrapper
      PrimaryNav={
        <InAppNotificationProvider>
          <PrimaryNavDrawer />
        </InAppNotificationProvider>
      }
    >
      <Outlet context={context} />
    </BaseLayoutWrapper>
  );
};

export default BaseLayout;
